<svg
  *ngIf="icon"
  [attr.aria-label]="icon.name"
  [attr.width]="width ? width : size || icon.size.width"
  [attr.height]="height ? height : size || icon.size.height"
  [attr.viewBox]="viewBox || icon.viewBox"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <path *ngFor="let path of icon.paths" [attr.d]="path.data" [ngStyle]="{ fillRule: path.windingRule }"
          [attr.fill]="path.fill" [ngClass]="{'customColor': path.fill !== null && path.fill !== undefined}"
    />
    <rect *ngFor="let rect of icon.rects"
          [attr.x]="rect.x" [attr.y]="rect.y" [attr.width]="rect.width" [attr.height]="rect.height"
          [attr.fill]="rect.fill" />
  </g>
</svg>
